// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400,500,600,700,800);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell--link{color:var(--electric-indigo);font-weight:600;cursor:pointer}
.cell--link.loading{cursor:progress}
.cell--highlight{display:inline-flex;gap:.5rem;align-items:center;color:var(--electric-indigo);cursor:pointer}
.cell--highlight .icon{fill:var(--electric-indigo)}
.cell--error{display:inline-flex;gap:.5rem;align-items:center;color:var(--flame)}
.cell--error .icon{fill:var(--flame)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
